fragment flexiblePostsSliderLatest on flexibleSections_postsSliderLatest_BlockType {
    __typename
    title: plaintext
    description: richTextMinimal
}
